import { render } from "./CustomChartLegend.vue?vue&type=template&id=97be5778"
import script from "./CustomChartLegend.vue?vue&type=script&lang=js"
export * from "./CustomChartLegend.vue?vue&type=script&lang=js"

import "./CustomChartLegend.vue?vue&type=style&index=0&id=97be5778&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTd,QBadge,QTooltip});
